module.exports = __webpack_public_path__ + "static/media/aq.65afe1f1.svg";